enum Shade {
  DARK = 'dark',
  LIGHT = 'light',
}

enum IconStyle {
  SOLID = 'solid',
  REGULAR = 'regular',
  BRANDS = 'brands',
}

export { Shade, IconStyle };
